import { MapPin, DoorOpen, Key, PaperPlaneTilt, Microphone } from "@phosphor-icons/react";

/**
 * A stylized Show-Up Card that fills the empty right-side hero space on the
 * landing page. All values are fabricated demo data — no real addresses.
 */
export default function HeroShowUpCardMock() {
  return (
    <div className="relative select-none pointer-events-none" aria-hidden="true">
      <div className="absolute -top-4 -right-4 w-20 h-20 rounded-full opacity-20 blur-2xl" style={{ background: "#14b8a6" }}/>
      <div className="border-4 border-[#0b1220] bg-white shadow-[10px_10px_0_#0b1220] max-w-sm mx-auto rotate-[-1.5deg] hover:rotate-0 transition-transform">
        <div className="p-3 bg-[#0b1220] text-white">
          <div className="flex items-start gap-2">
            <MapPin weight="fill" size={16} className="text-cyan-300 mt-0.5"/>
            <div>
              <div className="font-display font-black text-lg leading-tight">742 Elm St</div>
              <div className="inline-block mt-1 px-1.5 py-0.5 bg-fuchsia-500 font-black uppercase text-[10px] tracking-widest">APT 2B</div>
            </div>
          </div>
          <div className="mt-2 flex flex-wrap gap-1">
            <span className="px-2 py-0.5 bg-emerald-500 font-black uppercase text-[9px] tracking-widest">✓ ENTER ANYTIME</span>
            <span className="px-2 py-0.5 bg-fuchsia-500 font-black uppercase text-[9px] tracking-widest">🎯 3 MORE WOS HERE</span>
          </div>
        </div>
        <div className="p-3 bg-red-50 border-b-4 border-red-600">
          <div className="text-[9px] font-black uppercase tracking-widest text-red-800">🚨 CALLBACK — WO#4681 · 11 days ago</div>
          <div className="text-[11px] text-red-900 italic mt-0.5">Bring the pressure gauge this time.</div>
        </div>
        <div className="p-3 bg-cyan-50 border-b-2 border-cyan-500">
          <div className="text-[9px] font-black uppercase tracking-widest text-cyan-800 mb-2">Access Codes</div>
          <div className="grid grid-cols-2 gap-1.5">
            <CodeBox icon={<DoorOpen weight="fill" size={12}/>} label="Building" value="7-4-2-1"/>
            <CodeBox icon={<Key weight="fill" size={12}/>} label="Unit Key" value="384029"/>
          </div>
        </div>
        <div className="p-3 flex items-center gap-2">
          <div className="h-11 px-3 bg-amber-400 border-2 border-[#0b1220] font-display font-black text-xs uppercase tracking-widest inline-flex items-center gap-1 shadow-[2px_2px_0_#0b1220]">
            <PaperPlaneTilt weight="fill" size={12}/> I'M HERE
          </div>
          <div className="h-11 px-3 bg-[#0b1220] text-white border-2 border-[#0b1220] font-display font-black text-xs uppercase tracking-widest inline-flex items-center gap-1 shadow-[2px_2px_0_#334155]">
            <Microphone weight="fill" size={12}/> VOICE NOTE
          </div>
        </div>
      </div>
    </div>
  );
}

const CodeBox = ({ icon, label, value }) => (
  <div className="p-1.5 bg-white border-2 border-cyan-300">
    <div className="flex items-center gap-1 text-[8px] font-black uppercase tracking-widest text-cyan-800">{icon}{label}</div>
    <div className="font-mono font-black text-sm">{value}</div>
  </div>
);
